/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import {fetchTC} from '../../api/sensorApi';
import { Button, Card, Loading, Option, Select, TextInput, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import Plot from 'react-plotly.js';
import { InfoCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { getFeatureName, valueToColor } from '../../util/helperFunctions';
import { toast } from 'react-toastify';
import { helperTexts } from '../../util/helperTexts';

const CATEGORY_OPTIONS = [
    {
        label: "Last 6 months",
        value: 1,
    },
    {
        label: "Life time",
        value: 0,
    },
];


const REPLICATION_CATEGORY_OPTIONS = [
    {
        label: "Life time",
        value: 0,
    }
]

const DetailsTopContributors = (props) => {
    const {
        pathPrefix,
        corrosionLocationID,
        start,
        end,
        isRealSensor = true,
    } = props;

    const [topContributorsData, setTopContributors] = useState(null);
    const [numberOfTopContributors, setNumberOfTopContributors] = useState(
        5,
        null
    );
    const [debouncedNumberOfTopContributors, setDebouncedNumberOfTopContributors] = useState(numberOfTopContributors);
    const [categorySelect, setSelectedCategory] = useState(isRealSensor ? 1 : 0);
    const [errorText, setErrorText] = useState(null);
    const [loading, setLoading] = useState(false);

    const replicationHelp = helperTexts.topContributor.replicationInfo;

    // Debounce numberOfTopContributors state update
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedNumberOfTopContributors(numberOfTopContributors);
        }, 500); // 500ms delay for debounce

        return () => {
            clearTimeout(handler);
        };
    }, [numberOfTopContributors]);

    useEffect(() => {

        if (debouncedNumberOfTopContributors) {
            setLoading(true);
            fetchTC(`${pathPrefix}TopContributors`, {
                id: corrosionLocationID,
                limit: debouncedNumberOfTopContributors,
                category: categorySelect,
            }).then((topContributorsData) => {
                setLoading(false);
                setTopContributors(topContributorsData);
            }).catch((error) => {
                console.log(error);
                toast.error(`Cannot fetch Top Contributors data`);
            });
        }
    }, [corrosionLocationID, start, end, debouncedNumberOfTopContributors, categorySelect]);


    if (topContributorsData && topContributorsData.objs != null) {
        var topContributorsDataXValues = topContributorsData.objs.map((item) => item.value);
    }


    const dataToPlot =
        topContributorsData && topContributorsData.objs
            ? [
                {
                    type: "bar",
                    marker: {
                        color: topContributorsData.objs.map((item) =>
                            valueToColor(item.negativeValue)
                        ),
                        width: 1,
                    },
                    x: topContributorsDataXValues,
                    y: topContributorsData.objs.map((item) => {
                        const name = item.name;
                        return getFeatureName(name);
                    }),
                    orientation: "h",
                },
            ]
            : null;

    var layout = {
        margin: {
            l: 205,
            r: 40,
            b: 40,
            t: 10,
        },
        yaxis: {
            categoryorder: "trace",
            autorange: "reversed",
        },
        xaxis: {
            title: {
                text: "Average Contribution to Corrosion Rate Prediction in %",
            },
            titlefont: {
                size: 15,
            },
        },
    };

    let config = {
        // responsive: true,
        showLink: false,
        displayModeBar: false,
    };

    // Assuming each bar requires 50px of vertical space and the base height is 300px
    const baseHeight = 200;
    const heightIncrement = 50;
    let totalHeight;
    if (+debouncedNumberOfTopContributors > 0) {
        totalHeight = baseHeight + (debouncedNumberOfTopContributors * heightIncrement)
    }

    return <div className='top-contributors-container'>
        <div className='top-contributors-header'>
            <h2>Contribution To Predicted CR in %</h2>
            <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>Contributors data time interval is last 2 years</div>} trigger={
                <Button variant='transparent' iconOnly icon={<InfoCircle />} />
            } />
        </div>
        {/* loader to be shown when no data is loaded */}
        {!topContributorsData && loading && <div className='loading-container'><Loading /></div>}
        {topContributorsData && topContributorsData.objs &&
            (<Card className='top-contributors-chart-card' bodyPadding={false}>
                <div className='contributor-chart-controls'>
                    <div className='chart-count-wrapper'>
                        <p className='data-label'>Number of Top Contributors</p>
                        <TextInput placeholder='Enter number' value={numberOfTopContributors}
                            type='number'
                            onChange={(e) => {
                                const value = e.target.value;
                                setErrorText(null);
                                if (value === '') {
                                    setErrorText("Number of contributors cannot be empty");
                                    setNumberOfTopContributors(value);
                                } else if (value > 0 && value <= (topContributorsData?.count || 100) && Number.isInteger(Number(value))) {
                                    setNumberOfTopContributors(value);
                                }
                                else if (value > (topContributorsData?.count || 100)) {
                                    if (topContributorsData?.count) {
                                        setErrorText("Number of contributors cannot exceed the total number of contributors " + topContributorsData?.count);
                                    }
                                    else {
                                        setErrorText("Number of contributors cannot exceed 100");
                                    }
                                }
                            }}
                        />
                        {errorText && <p className='data-label error-label'>{errorText}</p>}
                    </div>
                    <div className='chart-interval-wrapper'>
                        <div className='label-header'>
                            <p className='data-label'>Time Range</p>
                            {!isRealSensor && <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>{replicationHelp}</div>} trigger={
                                <Button variant='transparent' iconOnly icon={<InfoCircle />} />
                            } />}
                        </div>
                        <Select value={categorySelect} onChange={value => {
                            setSelectedCategory(value)
                        }} allowClear={false}>
                            {isRealSensor ? CATEGORY_OPTIONS.map(opt => (
                                <Option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </Option>
                            )) : REPLICATION_CATEGORY_OPTIONS.map(opt => (
                                <Option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </Option>
                            ))}
                        </Select>
                    </div>
                </div>
                {/* loader to be shown when no of contributors or selected interval is changed */}
                {loading ? <div className='loading-container'><Loading /></div> :
                    <>
                        <div className='top-contributors-chart-plot'>
                            <Plot
                                data={dataToPlot}
                                layout={layout}
                                config={config}
                                useResizeHandler={true}
                                style={{ width: "100%", height: `${totalHeight}px` }}
                            />
                        </div>
                        <div className='chart-legend'>
                            <div className='positive-legend'>
                                <div className="square-False"></div>
                                <p className='data-label'>Inhibitors Magnitude</p>
                            </div>
                            <div className='negative-legend'>
                                <div className="square-True"></div>
                                <p className='data-label'>Contributors Magnitude</p>
                            </div>
                        </div>
                    </>}

            </Card>
            )}
    </div>;
}

export default DetailsTopContributors